import request from "@/util/request";

/** 获取所有产品分类(包含图片的) */
export function getProductTypeWithImg() {
  return request({
    url: "/products/type",
    method: "get",
  });
}

/** 获取页脚展示产品分类 */
export function getIndexProductType() {
  return request({
    url: "/products/getType",
    method: "get",
  });
}

/** 根据类型id获取产品列表 */
export function getProductListByTypeId(params) {
  return request({
    url: "/products/list",
    method: "get",
    params,
  });
}
